import { fetchWithAuth } from "./fetchWithAuth";

const API_BASE = process.env.REACT_APP_API_BASE;

export const getInvitationQuotes = async () => {
  const response = await fetchWithAuth(`${API_BASE}/invitation-quotes`, {
    method: "GET",
  });

  if (!response || !response.ok) {
    const text = response ? await response.text() : "";
    throw new Error(text || "Неуспешно вчитување на готови пораки.");
  }

  return response.json();
};
